import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Range } from "react-range";

export const PriceRangeSlider = ({
  min,
  max,
  tempMinPrice,
  tempMaxPrice,
  handlePriceChange,
}) => {
  const { t } = useTranslation()
  const [values, setValues] = useState([tempMinPrice, tempMaxPrice]);
  const [hoveredThumb, setHoveredThumb] = useState(null);

  // Sync with parent if tempMinPrice / tempMaxPrice change
  useEffect(() => {
    setValues([tempMinPrice, tempMaxPrice]);
  }, [tempMinPrice, tempMaxPrice]);

  const handleChange = (newValues) => {
    let [newMin, newMax] = newValues;

    // Clamp values inside allowed range
    newMin = Math.max(min, Math.min(newMin, max));
    newMax = Math.max(min, Math.min(newMax, max));

    // Ensure min <= max
    if (newMin > newMax) [newMin, newMax] = [newMax, newMin];

    setValues([newMin, newMax]);
    handlePriceChange([newMin, newMax]);
  };

  return (
    <div className="price-range-container mt-4" style={{ width: "100%", padding: "10px 0" }}>
      <Range
        step={1}
        min={min}
        max={max}
        values={values}
        onChange={handleChange}
        renderTrack={({ props, children }) => (
          <div
            ref={props.ref}
            style={{
              height: "6px",
              width: "100%",
              background: "var(--light-gray)",
              position: "relative",
              borderRadius: "5px",
            }}
          >
            <div
              style={{
                position: "absolute",
                height: "6px",
                background: "var(--secondary-light-color)",
                borderRadius: "5px",
                left: `${((values[0] - min) / (max - min)) * 100}%`,
                width: `${((values[1] - values[0]) / (max - min)) * 100}%`,
              }}
            />
            {children}
          </div>
        )}
        renderThumb={({ props, index }) => (
          <div
            {...props}
            onMouseEnter={() => setHoveredThumb(index)}
            onMouseLeave={() => setHoveredThumb(null)}
            style={{
              ...props.style,
              height: "18px",
              width: "18px",
              backgroundColor: "var(--secondary-light-color)",
              borderRadius: "50%",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {hoveredThumb === index && (
              <div
                style={{
                  position: "absolute",
                  top: "-30px",
                  background: "#111111",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: "5px",
                  fontSize: "12px",
                  whiteSpace: "nowrap",
                }}
              >
                €{values[index]}
              </div>
            )}
          </div>
        )}
      />

      {/* Input Fields */}
      <div className="d-flex gap-2 mt-4 align-items-center">
        {/* Min Price */}
        <div className="d-flex flex-column">
          <label className="text-muted" style={{ fontSize: "14px", fontWeight: "500" }}>
            {t("Min_Price")}
          </label>
          <div style={{ position: "relative" }}>
            <input
              type="number"
              className="form-control price-input"
              value={values[0]}
              onChange={(e) => handleChange([Number(e.target.value), values[1]])}
              style={{ paddingRight: "20px", textAlign: "left" }}
            />
            <span
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "var(--secondary-color)",
                fontSize: "18px",
                pointerEvents: "none",
              }}
            >
              €
            </span>
          </div>
        </div>

        {/* Max Price */}
        <div className="d-flex flex-column">
          <label className="text-muted" style={{ fontSize: "14px", fontWeight: "500" }}>
            {t("Max_Price")}
          </label>
          <div style={{ position: "relative" }}>
            <input
              type="number"
              className="form-control price-input"
              value={values[1]}
              onChange={(e) => handleChange([values[0], Number(e.target.value)])}
              style={{ paddingRight: "20px", textAlign: "left" }}
            />
            <span
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                color: "var(--secondary-color)",
                fontSize: "18px",
                pointerEvents: "none",
              }}
            >
              €
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
